exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".keyNotifier{background-color:#f6f8fb;text-align:center;padding:0px 15px;height:0;transition:all .5s;overflow:hidden}.keyNotifier p{margin:0;font-size:13px;color:#8a8a8a;display:inline-block;margin:0px 10px}.keyNotifier .btn{background-color:transparent;border:0;color:#acacac;display:inline-block;font-size:12px}.keyNotifier .btn-prim{color:#265390}.keyNotifier.show{padding:10px 15px;height:49px}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/api-key/sub/notifier.scss
// module id = 1349
// module chunks = 4